import { render } from "./TeamBlock.vue?vue&type=template&id=f5201904&scoped=true"
import script from "./TeamBlock.vue?vue&type=script&lang=js"
export * from "./TeamBlock.vue?vue&type=script&lang=js"

import "./TeamBlock.vue?vue&type=style&index=0&id=f5201904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5201904"]])

export default __exports__